import React from "react";
import TopBar from "../../components/TopBar";
import QRCode from "react-qr-code";
import { useLocation } from "react-router-dom";

const QrCode = () => {
  const { sessionId } = useLocation()?.state;

  return (
    <div>
      <TopBar title="Qr Code" />
      <div className="w-full h-[80vh] flex flex-col items-center justify-center">
        <QRCode value={`${window.location.origin}/survey?id=${sessionId}`} />
        <p className="mt-2">
          {window.location.origin}/survey?id={sessionId}
        </p>
      </div>
    </div>
  );
};

export default QrCode;
